//       getThirdLevelDomain
function getThirdLevelDomain(url) {
	try {
		// Parse the URL using the built-in URL object
		const hostname = new URL(url).hostname;

		// Split into parts
		const parts = hostname.split('.');

		// If there are fewer than 3 parts, there’s no 3rd-level domain
		if (parts.length < 3) {
			return null;
		}

		// The 3rd-level domain is the 3rd item from the end
		return parts[parts.length - 3];
	} catch (e) {
		console.error("Invalid URL:", e.message);
		return null;
	}
}

//       isDevEnv
function isDevEnv(str) {

	const regex = /^([A-Za-z]{2})-dev-app$/;

	const match = str.match(regex);
	if (match) {
		return match[1]; // the 2 letters
	}
	return null; // not matching
}

const $static = (url) => {

	let subdomain = getThirdLevelDomain( window.location.href );
	let devEnvMachine = isDevEnv( subdomain );

	if( devEnvMachine ) {

		return `https://${devEnvMachine}-dev-static.checkngo.pro/ai-chat${url}`;

	} else if( subdomain == 'app-qa' ) {

		return `https://static-qa.checkngo.link/ai-chat${url}`;

	} else if( subdomain == 'app' ) {

		return `https://static.checkngo.link/ai-chat${url}`;
	}

}

const $translation = (string) => {
	let result = string;

	if (window.__cng_common?.extract_translation) {
		let lang = "en";

		if (Cookie?.get) {
			lang = Cookie.get("__cng_lang");
		}

		result = window.__cng_common.extract_translation(string, lang);
	}

	return typeof result !== "string" ? JSON.stringify(result) : result;
};

const $getLanguage = () => {
	let lang = "en";

	if (Cookie?.get) {
		lang = Cookie.get("__cng_lang");
	}

    return lang;
};

const $price = (price, include_currency_symbol = false) => {
	if (!window.__cng_common.price_format) return price;
	else {
		if (isNaN(price)) {
			return "0.00";
		}
		return window.__cng_common.price_format(price, include_currency_symbol);
	}
};

export { $static, $translation, $price, $getLanguage };
